import { render, staticRenderFns } from "./TemplateDuplicatePopup.vue?vue&type=template&id=a341fe20&lang=pug&"
import script from "./TemplateDuplicatePopup.vue?vue&type=script&lang=js&"
export * from "./TemplateDuplicatePopup.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDuplicatePopup.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a341fe20')) {
      api.createRecord('a341fe20', component.options)
    } else {
      api.reload('a341fe20', component.options)
    }
    module.hot.accept("./TemplateDuplicatePopup.vue?vue&type=template&id=a341fe20&lang=pug&", function () {
      api.rerender('a341fe20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/template/TemplateDuplicatePopup.vue"
export default component.exports